export default __webpack_public_path__ + "static/media/Header.49245e21.png";